"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.mediaQueryMixin = void 0;
var _mediaMixin = require("./mediaMixin");
/** @mixin mediaQueryMixin */
/**
 * Adds support for the `mediaQuery` prop on the component. The `mediaQuery` prop accepts an object
 * where the keys are the media breakpoints, and the values are props that will be used at the given
 * breakpoint.
 *
 * Note: The props passed to the styles function are only the props defined on the mediaQuery
 * object. If you need access to all of the component props, you can make your styles function
 * return another function that will receive all the props, e.g.
 * "const styles = mediaProps => props => css``".
 *
 * @see {@link mediaMixin}
 *
 * @example
 * import { css } from 'styled-components';
 * import { mediaQueryMixin } from '@zillow/constellation';
 *
 * const colorCSS = mediaProps => css`
 *     background: ${mediaProps.backgroundColor};
 *     color: ${mediaProps.color};
 * `;
 *
 * const Component = styled.div`
 *     ${mediaQueryMixin(colorCSS)}
 * `;
 *
 * <Component mediaQuery={{ sm: { color: 'red' }, md: { backgroundColor: 'blue' } }}>
 *    Component with colors
 * </Component>
 *
 * @method
 * @param {function|CSSObject} styles - The styles to be applied at the given breakpoint.
 *     While this can be a simple CSSObject, it should usually be a function that takes
 *     `mediaProps` as the only argument and returns a CSSObject. `mediaProps` only includes the
 *     values defined in the `mediaQuery` object for the given breakpoint.
 * @return {Interpolation}
 */
var mediaQueryMixin = function mediaQueryMixin(styles) {
  return function (props) {
    var mediaQuery = props.mediaQuery;
    if (!mediaQuery) {
      return '';
    }
    var responsiveStyles = [];
    Object.keys(mediaQuery).forEach(function (breakpoint) {
      responsiveStyles.push((0, _mediaMixin.mediaMixin)(breakpoint, styles)(mediaQuery[breakpoint]));
    });
    return responsiveStyles;
  };
};
exports.mediaQueryMixin = mediaQueryMixin;